import { render } from "./captcha-panel.vue?vue&type=template&id=9b7ad918&scoped=true"
import script from "./captcha-panel.vue?vue&type=script&lang=ts"
export * from "./captcha-panel.vue?vue&type=script&lang=ts"

import "./captcha-panel.vue?vue&type=style&index=0&id=9b7ad918&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9b7ad918"

export default script